import { ReactElement } from 'react';
import deviceIcon from './device.png';

// @ts-expect-error Hack to reduce the size of the bundle
import Check from 'react-feather/dist/icons/check';
// @ts-expect-error Hack to reduce the size of the bundle
import MoreVertical from 'react-feather/dist/icons/more-vertical';
// @ts-expect-error Hack to reduce the size of the bundle
import Wifi from 'react-feather/dist/icons/wifi';
// @ts-expect-error Hack to reduce the size of the bundle
import Send from 'react-feather/dist/icons/send';
// @ts-expect-error Hack to reduce the size of the bundle
import MapPin from 'react-feather/dist/icons/map-pin';
// @ts-expect-error Hack to reduce the size of the bundle
import Smartphone from 'react-feather/dist/icons/smartphone';
// @ts-expect-error Hack to reduce the size of the bundle
import ChevronDown from 'react-feather/dist/icons/chevron-down';
// @ts-expect-error Hack to reduce the size of the bundle
import ChevronUp from 'react-feather/dist/icons/chevron-up';
// @ts-expect-error Hack to reduce the size of the bundle
import ChevronLeft from 'react-feather/dist/icons/chevron-left';
// @ts-expect-error Hack to reduce the size of the bundle
import ChevronRight from 'react-feather/dist/icons/chevron-right';
// @ts-expect-error Hack to reduce the size of the bundle
import HelpCircle from 'react-feather/dist/icons/help-circle';
// @ts-expect-error Hack to reduce the size of the bundle
import ArrowUp from 'react-feather/dist/icons/arrow-up';
// @ts-expect-error Hack to reduce the size of the bundle
import ArrowDown from 'react-feather/dist/icons/arrow-down';
// @ts-expect-error Hack to reduce the size of the bundle
import AlertTriangle from 'react-feather/dist/icons/alert-triangle';
// @ts-expect-error Hack to reduce the size of the bundle
import Sliders from 'react-feather/dist/icons/sliders';
// @ts-expect-error Hack to reduce the size of the bundle
import CreditCard from 'react-feather/dist/icons/credit-card';
// @ts-expect-error Hack to reduce the size of the bundle
import List from 'react-feather/dist/icons/list';
// @ts-expect-error Hack to reduce the size of the bundle
import X from 'react-feather/dist/icons/x';
// @ts-expect-error Hack to reduce the size of the bundle
import Bell from 'react-feather/dist/icons/bell';
// @ts-expect-error Hack to reduce the size of the bundle
import Crosshair from 'react-feather/dist/icons/crosshair';
// @ts-expect-error Hack to reduce the size of the bundle
import Clipboard from 'react-feather/dist/icons/clipboard';
// @ts-expect-error Hack to reduce the size of the bundle
import Zap from 'react-feather/dist/icons/zap';
// @ts-expect-error Hack to reduce the size of the bundle
import Calendar from 'react-feather/dist/icons/calendar';
// @ts-expect-error Hack to reduce the size of the bundle
import Search from 'react-feather/dist/icons/search';
// @ts-expect-error Hack to reduce the size of the bundle
import Activity from 'react-feather/dist/icons/activity';
// @ts-expect-error Hack to reduce the size of the bundle
import Globe from 'react-feather/dist/icons/globe';
// @ts-expect-error Hack to reduce the size of the bundle
import BarChart from 'react-feather/dist/icons/bar-chart';
// @ts-expect-error Hack to reduce the size of the bundle
import Settings from 'react-feather/dist/icons/settings';
// @ts-expect-error Hack to reduce the size of the bundle
import ShoppingCart from 'react-feather/dist/icons/shopping-cart';
// @ts-expect-error Hack to reduce the size of the bundle
import PlusCircle from 'react-feather/dist/icons/plus-circle';
// @ts-expect-error Hack to reduce the size of the bundle
import Edit2 from 'react-feather/dist/icons/edit-2';
// @ts-expect-error Hack to reduce the size of the bundle
import Trash2 from 'react-feather/dist/icons/trash-2';
// @ts-expect-error Hack to reduce the size of the bundle
import Camera from 'react-feather/dist/icons/camera';
// @ts-expect-error Hack to reduce the size of the bundle
import Users from 'react-feather/dist/icons/users';
// @ts-expect-error Hack to reduce the size of the bundle
import MinusCircle from 'react-feather/dist/icons/minus-circle';
// @ts-expect-error Hack to reduce the size of the bundle
import ArrowDownCircle from 'react-feather/dist/icons/arrow-down-circle';
// @ts-expect-error Hack to reduce the size of the bundle
import CheckCircle from 'react-feather/dist/icons/check-circle';
// @ts-expect-error Hack to reduce the size of the bundle
import Disc from 'react-feather/dist/icons/disc';
// @ts-expect-error Hack to reduce the size of the bundle
import AlignJustify from 'react-feather/dist/icons/align-justify';
// @ts-expect-error Hack to reduce the size of the bundle
import Info from 'react-feather/dist/icons/info';
// @ts-expect-error Hack to reduce the size of the bundle
import Lock from 'react-feather/dist/icons/lock';
// @ts-expect-error Hack to reduce the size of the bundle
import MessageCircle from 'react-feather/dist/icons/message-circle';
// @ts-expect-error Hack to reduce the size of the bundle
import Eye from 'react-feather/dist/icons/eye';
// @ts-expect-error Hack to reduce the size of the bundle
import EyeOff from 'react-feather/dist/icons/eye-off';
// @ts-expect-error Hack to reduce the size of the bundle
import RefreshCw from 'react-feather/dist/icons/refresh-cw';
// @ts-expect-error Hack to reduce the size of the bundle
import Power from 'react-feather/dist/icons/power';

export type UIIconName =
    | 'check'
    | 'more-vertical'
    | 'wifi'
    | 'send'
    | 'map-pin'
    | 'smartphone'
    | 'chevron-down'
    | 'chevron-up'
    | 'chevron-left'
    | 'chevron-right'
    | 'help-circle'
    | 'arrow-up'
    | 'arrow-down'
    | 'alert-triangle'
    | 'sliders'
    | 'credit-card'
    | 'list'
    | 'x'
    | 'bell'
    | 'crosshair'
    | 'clipboard'
    | 'zap'
    | 'calendar'
    | 'search'
    | 'activity'
    | 'globe'
    | 'bar-chart'
    | 'settings'
    | 'shopping-cart'
    | 'plus-circle'
    | 'edit-2'
    | 'trash-2'
    | 'camera'
    | 'users'
    | 'minus-circle'
    | 'arrow-down-circle'
    | 'check-circle'
    | 'disc'
    | 'device'
    | 'align-justify'
    | 'info'
    | 'lock'
    | 'message-circle'
    | 'eye'
    | 'eye-off'
    | 'refresh-cw'
    | 'power';

export type UIIconProps = {
    name: UIIconName;
    color?: string;
    size?: number;
    className?: string;
};
export function UIIcon(props: UIIconProps): ReactElement {
    const { name, color, size, className } = props;

    if (name === 'device') {
        return <LwdIcon {...props} />;
    }

    const LeftIcon = getIconComponent(name);
    // @ts-expect-error Hack to reduce the size of the bundle
    return <LeftIcon color={color} size={size} className={className} />;
}

function LwdIcon(props: UIIconProps): ReactElement {
    const { size } = props;
    return (
        <img
            src={deviceIcon}
            style={{
                width: size,
                height: size
            }}
        />
    );
}

const getIconComponent = (iconName: UIIconName): unknown => {
    switch (iconName) {
        case 'check':
            return Check;
        case 'more-vertical':
            return MoreVertical;
        case 'wifi':
            return Wifi;
        case 'send':
            return Send;
        case 'map-pin':
            return MapPin;
        case 'smartphone':
            return Smartphone;
        case 'chevron-down':
            return ChevronDown;
        case 'chevron-up':
            return ChevronUp;
        case 'chevron-left':
            return ChevronLeft;
        case 'chevron-right':
            return ChevronRight;
        case 'help-circle':
            return HelpCircle;
        case 'arrow-up':
            return ArrowUp;
        case 'arrow-down':
            return ArrowDown;
        case 'alert-triangle':
            return AlertTriangle;
        case 'sliders':
            return Sliders;
        case 'credit-card':
            return CreditCard;
        case 'list':
            return List;
        case 'x':
            return X;
        case 'bell':
            return Bell;
        case 'crosshair':
            return Crosshair;
        case 'clipboard':
            return Clipboard;
        case 'zap':
            return Zap;
        case 'calendar':
            return Calendar;
        case 'search':
            return Search;
        case 'activity':
            return Activity;
        case 'globe':
            return Globe;
        case 'bar-chart':
            return BarChart;
        case 'settings':
            return Settings;
        case 'shopping-cart':
            return ShoppingCart;
        case 'plus-circle':
            return PlusCircle;
        case 'edit-2':
            return Edit2;
        case 'trash-2':
            return Trash2;
        case 'camera':
            return Camera;
        case 'users':
            return Users;
        case 'minus-circle':
            return MinusCircle;
        case 'arrow-down-circle':
            return ArrowDownCircle;
        case 'check-circle':
            return CheckCircle;
        case 'disc':
            return Disc;
        case 'align-justify':
            return AlignJustify;
        case 'info':
            return Info;
        case 'lock':
            return Lock;
        case 'message-circle':
            return MessageCircle;
        case 'eye':
            return Eye;
        case 'eye-off':
            return EyeOff;
        case 'refresh-cw':
            return RefreshCw;
        case 'power':
            return Power;
        default:
            throw new Error(`Unknown icon name: ${iconName}`);
    }
};
